import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: 0,
  },
  inputPlaceholder: {
    position: "absolute",
    left: 30,
  },
  add: {
    marginLeft: 10,
  },
}));

export default useStyles;
